import React, { Component } from 'react';

import { InView } from 'react-intersection-observer';
import anime from 'animejs';

class AnimatedStroke extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inView: false,
      animated: false,
    };

    this.svgContainer = React.createRef();
  }

  componentDidMount() {
    const path = this.svgContainer.current.querySelector('path');
    anime.set(path, {
      strokeDashoffset: anime.setDashoffset,
    });

    this.svgContainer.current
      .querySelector('svg')
      .setAttribute('filter', 'url(#grain)');
  }

  componentDidUpdate() {
    const { inView, animated } = this.state;
    const { animProps } = this.props;

    if (!animated) {
      if (inView) {
        const path = this.svgContainer.current.querySelector('path');
        anime({
          targets: path,
          strokeDashoffset: 0,
          easing: 'linear',
          duration: 1200,
          ...animProps,
        });

        this.setState({ animated: true });
      }
    }
  }

  render() {
    return (
      <InView onChange={inView => this.setState({ inView })}>
        <div ref={this.svgContainer}>{this.props.svg}</div>
      </InView>
    );
  }
}

export default AnimatedStroke;
